import { createStart } from "@tanstack/react-start";

// Opt public browse routes into SSR while wallet and execution surfaces retain
// their browser lifecycle. Ancestors explicitly opt in so children can render.
export const startInstance = createStart(() => ({ defaultSsr: false }));
